import React, { useState } from "react";
import "./contactus.css";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Your WhatsApp Number (with country code, no + sign)
    const phoneNumber = "94771199190";

    // WhatsApp Message
    const whatsappMessage = `
*New Contact Form Message*

Full Name: ${formData.name}
Email: ${formData.email}
Subject: ${formData.subject}
Message:
${formData.message}
    `;

    // Encode message for URL
    const encodedMessage = encodeURIComponent(whatsappMessage);

    // Open WhatsApp Chat
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    window.open(whatsappURL, "_blank");

    // Clear Form
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div className="contact-container">

      {/* HEADER */}
      <section className="contact-header">
        <h1>Contact Us</h1>
        <p>
          We'd love to hear from you! Get in touch with us for any queries
        </p>
      </section>

      {/* CONTACT INFO */}
      <section className="contact-info-contactus">
        <div className="contact-details-contactus">
          <h2>Our Office</h2>

          <p>
            <strong>Address:</strong> 77 Modera St, Colombo 01500, Sri Lanka
          </p>

          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:info@drjerymedico.com">
              info@drjerymedico.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong>{" "}
            <a href="tel:+94771199190">077 119 9190</a>
          </p>
        </div>
      </section>

      {/* GOOGLE MAP */}
      <div className="contact-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.3419994476335!2d79.8677090105756!3d6.9689194930026135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae259cdd7f13adb%3A0x33d81dce321a8d99!2sFamily%20Clinic!5e0!3m2!1sen!2slk!4v1778165731859!5m2!1sen!2slk"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Family Clinic Location Map"
        />
      </div>

      {/* CONTACT FORM */}
      <section className="contact-form">
        <div className="form-container">
          <div className="form-content">

            <h2>Send Us a Message</h2>

            <form onSubmit={handleSubmit}>

              <div className="form-group-contactus">
                <label htmlFor="name">Full Name</label>

                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter Your Full Name"
                  required
                />
              </div>

              <div className="form-group-contactus">
                <label htmlFor="email">Email Address</label>

                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter Your Email Address"
                  required
                />
              </div>

              <div className="form-group-contactus">
                <label htmlFor="subject">Subject</label>

                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Enter Subject"
                  required
                />
              </div>

              <div className="form-group-contactus">
                <label htmlFor="message">Message</label>

                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Type Your Message Here..."
                  required
                ></textarea>
              </div>

              <div className="form-group-contactus">
                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </div>

            </form>

          </div>
        </div>
      </section>

    </div>
  );
}

export default ContactUs;